module.exports = __webpack_public_path__ + "img/talk_6.c0a51eb4.png";